import { render, staticRenderFns } from "./PayMongoPayment.vue?vue&type=template&id=d87fe8ec&"
import script from "./PayMongoPayment.vue?vue&type=script&lang=js&"
export * from "./PayMongoPayment.vue?vue&type=script&lang=js&"
import style0 from "./PayMongoPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports